import {CODIGO_LOCALIZA, CODIGO_LOCALIZA_PESADOS} from '../reducers/constants';

export const parkingSolicitationRequiresEmail = (companyCode, refusalTypeCode) =>
  (companyCode === CODIGO_LOCALIZA || companyCode === CODIGO_LOCALIZA_PESADOS) &&
  (refusalTypeCode === 'RECUSARECUSA' || refusalTypeCode === 'RECUSAOFICINAINEXISTENTE');
